<div class="container-left" id="landing-stats-left">
  <div class="icon">
    <span class="icon-learniz-mountains"></span>
  </div>
  <h2><span [innerHTML]="'landing-stats.my-stats' | wording"></span></h2>
</div>

<div class="container-right landing-stats-right" id="landing-stats-right">
  <div class="stats">
    <div class="stats-inner">
      <h3 [innerHTML]="'learniz.landing-page.stats-title' | wording"></h3>
      @if (stats$ | async; as stats) {
        <div class="progress-bar">
          <div
            class="bar"
            [style.width.%]="stats.percentage"
            [ngClass]="[stats.percentage < 10 ? 'number-begin' : '', stats.percentage > 90 ? 'number-end' : '']">
            <div class="bar-label">{{ stats.percentage | number: '1.0-0' }} %</div>
          </div>
        </div>
        <learniz-stats [stats]="stats"></learniz-stats>
        @if (mode !== linkMode.PREVIEW && mode !== linkMode.STANDALONE) {
          <div class="block-stats block-stats-simple">
            @if (stats.hasVideo) {
              <div class="stats-videos stats-simple">
                <p class="number">{{ stats.nbVideo }}</p>
                <h5 [innerHTML]="'learniz.landing-page.stats.videos' | wording"></h5>
              </div>
            }
            @if (stats.hasPodcast) {
              <div class="stats-podcast stats-simple">
                <p class="number">{{ stats.nbPodcast }}</p>
                <h5 [innerHTML]="'learniz.landing-page.stats.podcast' | wording"></h5>
              </div>
            }
            @if (stats.hasGame) {
              <div class="stats-games stats-simple">
                <p class="number">{{ stats.nbGames }}</p>
                <h5 [innerHTML]="'learniz.landing-page.stats.games' | wording"></h5>
              </div>
            }
            @if (stats.hasDownload) {
              <div class="stats-documents stats-simple">
                <p class="number">{{ stats.nbDownload }}</p>
                <h5 [innerHTML]="'learniz.landing-page.stats.documents' | wording"></h5>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
</div>
